module.exports = __webpack_public_path__ + "static/media/SHSProdIcons_Security_Camera.50aaaa03.svg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/pages/homepage/resources/SHSProdIcons_Security_Camera.svg
// module id = 3433
// module chunks = 0